import { fontSize } from '@mui/system';
import React from 'react';

function Header({ reportData }) {
  // Extract values with fallbacks matching the sample image
  const dateAndTime = reportData?.reporteDate || '16/04/2026 (15:11:50)';
  const controlNumber = reportData?.controlNumber || '10852865760';

  // Direct image URL converted from the Wikimedia file page
  const logoUrl = 'https://upload.wikimedia.org/wikipedia/commons/4/4e/TU-CIBIL-logo.jpg';

  return (
    <header style={styles.headerContainer}>
      {/* Left Content Area (Text details + Yellow bar underneath) */}
      <div style={styles.leftSection}>
        <div style={styles.dataRow}>
          {/* Report Date & Time Block */}
          <div style={styles.dataBlock}>
            <span style={styles.label}>REPORT DATE & TIME : </span>
            <span style={styles.value}>{dateAndTime}</span>
          </div>

          {/* Vertical Divider */}
          <span style={styles.divider}>|</span>

          {/* Control Number Block */}
          <div style={styles.dataBlock}>
            <span style={styles.label}>CONTROL NUMBER : </span>
            <span style={styles.value}>{controlNumber}</span>
          </div>
        </div>

        {/* Yellow Bottom Bar */}
        <div style={styles.yellowBar} />
      </div>

      {/* Right Content Area (TransUnion CIBIL Logo) */}
      <div style={styles.logoSection}>
        <img
          src={logoUrl}
          alt="TransUnion CIBIL Logo"
          style={styles.logoImage}
        />
      </div>
    </header>
  );
}

const styles = {
  headerContainer: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'flex-end',
    width: '100%',
    padding: '20px 10px',
    backgroundColor: '#ffffff',
fontFamily: '"Times New Roman", Times, Georgia, serif',
    boxSizing: 'border-box',
  },
  leftSection: {
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    marginRight: '24px',
  },
  dataRow: {
    display: 'flex',
    alignItems: 'center',
    gap: '28px',
    marginBottom: '8px',
  },
  dataBlock: {
    display: 'flex',
    alignItems: 'end',
    fontSize: '13px',
    letterSpacing: '0.3px',
  },
  label: {
    fontSize: '10px',
    color: '#00a1de', // Exact CIBIL Cyan Blue
    fontWeight: '600',
    textTransform: 'uppercase',
    marginRight: '4px',
  },
  value: {
        fontSize: '11px',

    color: '#000000',
    fontWeight: '700',
  },
  divider: {
    color: '#333333',
    fontWeight: '300',
    fontSize: '18px',
    lineHeight: '1',
    userSelect: 'none',
  },
  yellowBar: {
    height: '4px',
    backgroundColor: '#ffc20e', // CIBIL Accent Yellow
    width: '100%',
  },
  logoSection: {
    display: 'flex',
    alignItems: 'flex-end',
    justifyContent: 'flex-end',
  },
  logoImage: {
    height: '46px',
    width: 'auto',
    objectFit: 'contain',
  },
};

export default Header;